<div #bgs class="bgs"></div>
<div class="text">
    <div #text></div>
</div>
<div #black class="black"></div>